import { render, staticRenderFns } from "./GeneralSettingsOrderPayOnHold.vue?vue&type=template&id=3e681b5a&"
import script from "./GeneralSettingsOrderPayOnHold.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsOrderPayOnHold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports